export const PROGRAM_BENEFITS_1005_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_image: "",
    meta_hover_image: "",
    meta_alt_image: "",
    meta_title: "",
    meta_sub_title: "",
    meta_priority: "1",
  },

  METADATA_TITLES: {
    metadata: "Benefit cards",
  },

  PROGRAM_BENEFITS_1005_FIELDS_CONFIG: [
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title",
      label: "Title",
      value: "Experience the {CU Online} Advantage",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter title (wrap a phrase in { } to highlight it)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "title_start_color",
      label: "Title Color",
      value: "#1F1F1F",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title color (e.g., #1F1F1F)",
      required: false,
      defaultValue: "#1F1F1F",
    },
    {
      fieldName: "title_end_color",
      label: "Highlighted Text Color",
      value: "#E1473F",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter highlighted text color (e.g., #E1473F)",
      required: false,
      defaultValue: "#E1473F",
    },
    {
      fieldName: "description",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter description",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description_color",
      label: "Description Color",
      value: "#1F1F1F",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description color (e.g., #1F1F1F)",
      required: false,
      defaultValue: "#1F1F1F",
    },
    {
      fieldName: "button_text",
      label: "CTA Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA text (empty hides the lead button)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_color",
      label: "CTA Background Color",
      value: "#E1473F",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA background color (e.g., #E1473F)",
      required: false,
      defaultValue: "#E1473F",
    },
    {
      fieldName: "button_text_color",
      label: "CTA Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA text color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "card_hover_background_color",
      label: "Card Hover / Flip Background Color",
      value: "#E1473F",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter card hover & mobile flip-side color (e.g., #E1473F)",
      required: false,
      defaultValue: "#E1473F",
    },
    {
      fieldName: "status",
      label: "Program Benefits Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Program Benefits",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Icon",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Icon",
    },
    {
      header: "Hover Icon (Desktop)",
      fieldName: "meta_hover_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Hover Icon",
    },
    {
      header: "Icon Alt Text",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Icon Alt Text",
    },
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title",
      required: false,
    },
    {
      header: "Description (hover / flip side)",
      fieldName: "meta_sub_title",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Description",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: false,
    },
  ],
};
